import React from 'react';
import {Modal as BootstrapModal, ModalHeader, ModalBody} from 'reactstrap';

import ForgottenPasswordForm from '../../Forms/ForgottenPasswordForm/ForgottenPasswordForm.jsx';
import Modal from '../../../../shared/components//Modals/Modal.jsx';
import SubmitButton from '../../Forms/ForgottenPasswordForm/SubmitButton.jsx';

export default class ForgottenPasswordModal extends Modal {
  constructor(props) {
    super(props);
    this.close = () => this.props.closeModal()
    this.state = {
      success: false
    };
  }

  onSubmitSuccess = (result, dispatch, props) => {
    this.setState({
      success: true
    });
  }

  render() {
    return (
      <BootstrapModal toggle={this.close} isOpen={this.props.isOpen} className="forgotten-password-modal">
        <ModalHeader toggle={this.close}>Mot de passe oublié</ModalHeader>
        {(!this.state.success 
          ? <ModalBody key={0}>
            <p className="text-center">
              Afin de récupérer votre mot de passe, veuillez remplir le formulaire ci-dessous.
            </p>
            <ForgottenPasswordForm onSubmitSuccess={this.onSubmitSuccess} />
            <div className="text-center">
              <SubmitButton className="btn btn-primary my-3">
                Continuer
              </SubmitButton>
            </div>
          </ModalBody>
          : <ModalBody key={1}>
            <div className="callout callout-primary mt-0">
              Votre demande a bien été prise en compte, vous devriez recevoir un mail 
              dans quelques instants.
            </div>
            <div className="text-center">
              <button onClick={this.close} type="button" className="btn btn-outline-shy">
                Fermer
              </button>
            </div>
          </ModalBody>
        )}
      </BootstrapModal>
    )
  }
}
